import Button from '../../../shared/components/Button';
import { Dialog } from 'primereact/dialog';
import { CancellationToken } from '../../../shared/helpers/CancellationToken';

const BluetoothConnectionDialog = ({
  visible,
  visibleSetter,
  cancelToken
} : {
    visible: boolean,
    visibleSetter: (v:boolean) => void,
    cancelToken: CancellationToken | null
}) => {

    return (
        <Dialog
            visible={visible}
            onHide={() => { visibleSetter(false); }}
            style={{ width: '400px' }}
            showHeader={false}
            className="rounded-lg"
            position="bottom" // to stay out of the way of the Chrome dialog
        >
            <div className="px-6 py-4">
                <div className="center mt-4 mb-4">
                Connecting to watch.  Make sure the watch is on the Bluetooth screen.
                </div>
                <div>
                <Button
                    onClick={() => {cancelToken?.cancel()}}
                    style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '40%',
                    }}
                >
                    Cancel
                </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default BluetoothConnectionDialog;